import angular from 'angular';
import template from './featureFlags.config.jade';

export function FeatureFlagsConfigComponent() {
  "use strict";
  return {
    template,
    restrict: 'E'
  };
}

export default angular.module('featureFlagsConfig', [])
  .config(($stateProvider) => {
    "use strict";
    $stateProvider
    .state('featureFlagsConfig', {
      url: '/ff',
      template: '<feature-flags-config-form></feature-flags-config-form>'
    });
  })
.directive('featureFlagsConfigForm', FeatureFlagsConfigComponent)
.service('defaultFeatureFlags', () => {
  return [
    {
      key: "DebugLogs",
      active: false,
      name: "Debug Logs",
      description: "Toggles debug console logs"
    },
    {
      key: "GDCreateNewGame",
      active: false,
      name: "GD Create New Game",
      description: "Toggles the \"Button\" that brings Game Developers to the game creation form in the main dashboard."
    },
    {
      key: "SegmentsNestedRules",
      active: false,
      name: "Segments nested rules",
      description: "Ability to create nested rules in segment builder."
    },
    {
      key: "PlayerExplorerHiddenComparisonTrends",
      active: false,
      name: "Player Explorer Hidden Comparison Trends",
      description: "Shows benchmark trend only hovering on its User Group trend"
    },
    {
      key: "CPQICampaigns",
      active: false,
      name: "CPQI campaigns",
      description: "Enables CPQI campaigns actions in marketplace and campaign dashboard"
    },
    {
      key: "NativeVideo",
      active: false,
      name: "Native Video",
      description: "Shows Native Video creative type in campaign edit view"
    }
  ];
});


/** WEBPACK FOOTER **
 ** ./src/configs/featureFlags/featureFlags.config.js
 **/